module.exports = __webpack_public_path__ + "static/media/custom-03.d8fabf98.jpg";